export default __webpack_public_path__ + "static/media/newsletter-bg2.75652d19.jpg";